<template>
  <div class="left cadfm-flexitem-stretched">
    <action-panel>
      <action-bar>
        <b-navbar-nav>

          <action-button  @click="settings" icon="settings" bold :text="lang.button_Settings" :tooltip="lang.button_Settings" :disabled="settingsButtonStatus"/>

        </b-navbar-nav>
      </action-bar>
      <action-content>

        <Content :lang="lang.Content"></Content>
      </action-content>
    </action-panel>

 </div>
</template>



<script>
//import { mapState, mapMutations, mapActions, mapGetters, mapTypes } from 'vuex'
import ActionBar from '@/components/shared/ActionBar'
import ActionContent from '@/components/shared/ActionContent'
import ActionPanel from '@/components/shared/ActionPanel'
import ActionButton from '@/components/shared/ActionButton'

import Content from "@/components/Dashboard/Views/DashboardWidgets/Left/Content/Content"


export default {
  name: 'Left',
  components: {
    ActionBar,
    ActionContent,
    ActionPanel,
    ActionButton,
    Content
  },
  data () {
    return {
      settingsButtonStatus: false


    }
  },
  props:{
    lang: Object
  },
  computed: {

  },

  methods: {
    
    settings(){
      

      let func = function(){
        console.log("func");
      }
      
      const obj = {
        
        text: "",
        type: "dashboard_settings",
        buttons: 1,
        buttonName: "Close",
        size: "md",
        lang: this.lang.Content.modal_Settings,
        funcNo: "",
        funcYes: "",
        funcCustom: func
        
      };
      this.$store.dispatch("showModalComponent", obj);
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .action-bar.navbar {
    padding: 0px;
    border-bottom: 1px solid #666666;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/DashboardWidgets/Left/Left.vue